import React from 'react'
import { Route } from 'react-router-dom'

import ContextualHomepageController from './ContextualHomepageController'
import ContextualClinicalProcessController from './ContextualClinicalProcessController'
import ContextualClinicalProcessesController from './ContextualClinicalProcessesController'
import ContextualNotificationsController from './ContextualNotificationsController'
import ContextualUserController from './ContextualUserController'
import ContextualSettingsController from './ContextualSettingsController'
import ContextualTaskController from './ContextualTaskController'
import useSession from 'hooks/useSession'

const ContextualController = () => {
	const { user } = useSession()
	const isAdmin = user.roles?.includes?.('admin')

	return (
		<>
			<Route path='/clinical-process' exact />
			<Route path='/' exact component={ContextualHomepageController} />
			<Route
				path={'/clinical-processes/:clinicalProcessId'}
				component={ContextualClinicalProcessController}
			/>
			<Route
				path={['/clinical-processes']}
				exact
				component={ContextualClinicalProcessesController}
			/>
			<Route
				path='/notifications'
				exact
				component={ContextualNotificationsController}
			/>
			<Route
				path='/users/:userId'
				exact
				component={ContextualUserController}
			/>
			{isAdmin && (
				<Route
					path='/settings'
					component={ContextualSettingsController}
				/>
			)}
			{isAdmin && (
				<Route path='/tasks' component={ContextualTaskController} />
			)}
			{/* <Route path='/tasks' exact>
				<h2>Some stats about your performance</h2>
			</Route>
			<Route path='/users' exact>
				<h2>Some users stats</h2>
			</Route> */}
		</>
	)
}

ContextualController.displayName = 'ContextualController'

export default ContextualController
